<template>
  <div class="beneficios">
    <div class="row">
      <div class="col-xs-12">
        <button
          type="button"
          class="btn btn-primary btn-voltar"
          @click="$router.back()"
        >
          <font-awesome-icon :icon="'arrow-left'" />
          Voltar
        </button>
        <h2 class="page-header">Inserir Benefícios</h2>
      </div>
    </div>
    <div class="row margem-bottom">
      <div class="col-xs-12">
        <upload @loadCSV="loadCSV" :separador="';'" />
      </div>
    </div>
    <div v-if="model.body.length" class="row">
      <div class="col-xs-12">
        <h3>Pré Visualização</h3>
      </div>
      <div class="col-xs-12">
        <data-table :dados="model.body" :fields="fields">
          <template slot="columncustom" slot-scope="props">
            {{
              `de ${props.rowData.INICIO || '-----'} à ${props.rowData.FIM ||
                '-----'}`
            }}
          </template>
        </data-table>
      </div>
      <div class="col-xs-12 margem-bottom">
        <button
          @click="salvar()"
          class="btn btn-default"
          :disabled="carregando"
        >
          <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
          <font-awesome-icon v-else :icon="'save'" />
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '@/components/common/CSVImport'
import DataTable from '@/components/common/NoApiTable'
import { formatarMoeda, toDate } from '@/utils/strings.js'
import { request } from '@/request'

export default {
  inject: ['showConfirm'],
  components: { upload, DataTable },
  data() {
    return {
      carregando: false,
      model: {
        header: [],
        body: []
      },
      beneficios: [],
      fields: [
        {
          name: 'BENEFICIO',
          title: 'Benefício'
        },
        {
          name: 'DATA',
          title: 'Data'
        },
        {
          name: '__slot:column',
          title: 'Período'
        },
        {
          name: 'NOME',
          title: 'Nome'
        },
        {
          name: 'VALOR',
          title: 'Valor',
          titleClass: 'text-right',
          dataClass: 'text-right',
          callback(value) {
            return formatarMoeda(Number(value.replace(',', '.')))
          }
        }
      ]
    }
  },
  created() {
    request
      .get('assistencia/listar-beneficios')
      .then(response => {
        this.beneficios = response.data
      })
      .catch(error => {
        console.log(error.message)
      })
  },
  methods: {
    loadCSV(payload) {
      const checkFields = ['DATA', 'NOME', 'BENEFICIO', 'VALOR']

      for (let index = 0; index < checkFields.length; index++) {
        const element = checkFields[index]
        if (!payload.header.includes(element)) {
          this.$toastr.e(
            `${element} é um campo obrigatório! Verifique a planilha.`
          )
          return
        }
      }

      this.model.header = payload.header
      this.model.body = payload.body
    },
    salvar() {
      const me = this
      var config = {
        title: 'Deseja Salvar?',
        question: true,
        yes: () => {
          me.carregando = !me.carregando
          request
            .post('assistencia/pagamentos/salvar', this.rawInfo)
            .then(response => {
              this.$toastr.s(response.data.msg)
              this.$router.push('/admin/assistencia/pagamentos')
            })
            .catch(error => {
              const { data } = error.response
              this.$toastr.e(
                `Houve um erro na importação dos dados, verifique o arquivo na linha ${data.linha} e tente novamente.`
              )
              console.log(data.msg)
            })
            .then(() => {
              me.carregando = !me.carregando
            })
        }
      }
      this.showConfirm('Confirmar a inserção dos itens?', config)
    }
  },
  computed: {
    rawInfo() {
      return this.model.body.map(item => {
        const finder = sub => {
          return sub.sigla === item['BENEFICIO']
        }

        return {
          data: toDate(item['DATA']).toLocaleDateString('en-US'),
          periodo_inicio: item['INICIO']
            ? toDate(item['INICIO']).toLocaleDateString('en-US')
            : '',
          periodo_fim: item['FIM']
            ? toDate(item['FIM']).toLocaleDateString('en-US')
            : '',
          beneficiado: item['NOME'],
          cd_beneficio: this.beneficios.find(finder).codigo,
          valor: Number(item['VALOR'].replace(',', '.'))
        }
      })
    }
  }
}
</script>

<style>
.btn-voltar {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/assistencia/pagamentos/Save.vue